interface VerticalAxisProps {
  axisLabels: number[];
}

export function VerticalAxis({ axisLabels }: VerticalAxisProps) {
  const reversedLabels = axisLabels.slice().reverse();

  return (
    <div className="absolute inset-0 -z-10 grid">
      <div className="grid grid-rows-8 gap-sm">
        <div className="relative row-span-6 -my-px grid grid-flow-row border-y-px border-l-px border-emphasis-subtle">
          <div className="relative border-y-px border-l-px border-emphasis-subtle">
            <div className="absolute bottom-full right-full -mb-sm w-xl pr-sm text-right text-caption-md text-subtle">
              {axisLabels[axisLabels.length - 1]}
            </div>
          </div>
          {reversedLabels.map((label, index) => {
            if (!index) {
              return null;
            }

            return (
              <div
                key={label}
                className="relative border-y-px border-l-px border-emphasis-subtle"
              >
                <div className="absolute bottom-full right-full -mb-sm w-xl pr-sm text-right text-caption-md text-subtle">
                  {label}
                </div>
              </div>
            );
          })}
          <div className="absolute right-full top-full -mt-sm pl-px pr-sm text-right text-caption-md text-subtle">
            0
          </div>
        </div>
      </div>
    </div>
  );
}

VerticalAxis.displayName = 'VerticalAxis';
